import React, { Component } from 'react';
import deviceDOMHoc from '../../hocs/deviceDOMHoc';
import {
  inject,
  observer,
} from 'mobx-react';

@inject('remoteDisplayStore')
@observer
class RemoteDisplay extends Component {
  render() {
    const { device, remoteDisplayStore } = this.props;
    const { textToDisplay, isRedLightOn, isGreenLightOn } = remoteDisplayStore.getUIStatus(device.id);

    return (
      <div id={`device-${device.id}`} className={'device-gui device-gui--remote-display'}>
        <div className="device-label device-icon">
          <div className="device-type" title={`#${device.id}`}>{device.description}</div>
        </div>
        <div className="device-icon body">
          <div className="rd-lights">
            <div className={`rd-light rd-light-red ${isRedLightOn ? 'active' : ''}`}/>
            <div className={`rd-light rd-light-green ${isGreenLightOn ? 'active' : ''}`}/>
          </div>
          <div className="rd-display">{textToDisplay}</div>
        </div>
      </div>
    );
  }
}

export default deviceDOMHoc(RemoteDisplay);
